export default __webpack_public_path__ + "static/media/exterior3.339c1043.jpg";